<template>

  <div class="py-4">
    <a-spin style="z-index: 99999;" :spinning="loading">
      <jet-dialog-modal
          :show="createModel === true"
          @close="createModel = false"
      >
        <template #content>
          <div class="CustomRetroFlow__DND max-w-lg flex justify-center flex-col items-center m-auto">
            <div class="text-4xl font-bold text-gray-700 text-center mb-2">{{ modalTitle }}</div>
            <div class="self-stretch rounded-md bg-gray-100 px-4 py-5 sm:px-6 shadow-md">
              <div>
                <h3 class="block text-lg font-bold text-gray-700">Flow Name:</h3>
                <input
                    v-model="formData.name"
                    id="flowName"
                    type="text"
                    name="flowName"
                    class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md mb-4"
                    placeholder="Your Custom Flow Name"
                />
              </div>


              <div v-for="(element,index) of customFlow" class="p-2 bg-white rounded-md list-group-item">
                <div class="flex justify-between">
                  <div class="flex items-center">
                    <div
                        class="w-8 h-8 border-2 border-green-300 rounded-full text-lg text-white mr-4 flex justify-center items-center">
                        <span class="text-center text-green-600">
                          <span class="py-1 px-1 font-bold">{{ index + 1 }}</span>
                        </span>
                    </div>
                    <input v-model="element.name" class="border-gray-300 rounded-full" type="text"/>
                  </div>
                  <div class="flex items-center">
                    <button
                        class="
                          hover:text-red-400
                          relative
                          flex-1
                          inline-flex
                          items-center
                          justify-center
                          text-sm text-gray-700
                          font-medium
                          border border-transparent
                          rounded-bl-lg
                        "
                        @click="deleteStep(index)"
                    >
                      <TrashIcon class="hover:text-red-400 w-5 h-5 flex-shrink-0 text-red-700"></TrashIcon>
                    </button>
                    <button
                        class="
                          hover:text-blue-400
                          relative
                          flex-1
                          inline-flex
                          items-center
                          justify-center
                          text-sm text-gray-700
                          font-medium
                          border border-transparent
                          rounded-bl-lg
                        "
                        @click="
                          settingModal = true;
                          selectedStep = element;
                        "
                    >
                      <CogIcon class="hover:text-blue-400 w-5 h-5 flex-shrink-0 text-gray-700"></CogIcon>
                    </button>
                  </div>
                </div>
              </div>

              <div
                  class="bg-white mt-4 flex items-center justify-center p-2 rounded-lg cursor-pointer hover:bg-gray-200"
                  @click="addStep">
                <PlusCircleIcon class="hover:text-blue-400 w-5 h-5 flex-shrink-0 text-gray-700"/>
              </div>
            </div>
            <a-divider></a-divider>
            <button
                @click="modalSubmit"
                class="p-2 bg-blue-500 hover:bg-blue-400 w-full rounded-lg shadow text-md font-bold uppercase text-white">
              {{ modalButton }}
            </button>
          </div>
        </template>

        <template #footer>
          <div class="text-md text-blue-500 font-bold inline-block ml-1">agilesuite.io</div>
        </template>
      </jet-dialog-modal>
      <jet-dialog-modal
          :show="settingModal === true"
          @close="settingModal = false"
      >
        <template #content>
          <div class="max-w-lg flex justify-center flex-col items-center m-auto">
            <div class="text-4xl font-bold text-gray-700 text-center mb-2">Edit Step: {{ selectedStep.name }}</div>

            <div class="w-full mt-2">
              <h3 class="block text-lg font-bold text-gray-700">Step Description:</h3>
              <input
                  v-model="selectedStep.desc"
                  type="text"
                  name="flowName"
                  class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md mb-4"
                  placeholder="Your step description here"
              />
            </div>

            <div class="w-full mt-2">
              <h3 class="block text-lg font-bold text-gray-700">Step Permission(s):</h3>


              <div
                  class="self-stretch divide-y border-2 space-y-2 rounded-md bg-gray-100 px-4 py-5 sm:px-6 shadow-md">
                <div v-for="(value, name, index) in selectedStep.permissions" :key="name">

                  <div class="flex justify-between w-full font-black mt-3 text-black text-lg">
                    <label>{{ PERMISSION_DISPLAY_NAMES[name] }}: </label>
                    <a-switch :name="name" :checked="value" class="mt-2" @change="changePermission"/>
                  </div>

                </div>
              </div>
            </div>
            <a-divider></a-divider>
            <button
                @click=" settingModal = false"
                class="p-2 bg-blue-500 hover:bg-blue-400 w-full rounded-lg shadow text-md font-bold uppercase text-white">
              Back
            </button>
          </div>
        </template>
        <template #footer>
          <div class="text-md text-blue-500 font-bold inline-block ml-1">agilesuite.io</div>
        </template>
      </jet-dialog-modal>

      <div class="mb-10">
        <button
            type="button"
            class="
          relative
          block
          w-full
          border-2 border-gray-300 border-dashed
          rounded-lg
          p-12
          text-center
          hover:border-gray-400
          focus:outline-none
          focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500
        "
            @click="openCreateFlow"
        >
          <span class="block text-lg font-bold font-medium text-gray-900"> + Create a new custom retro flow </span>
        </button>
      </div>

      <ul role="list" class="grid grid-cols-12 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        <li v-for="flow in flows" :class="flow.is_default ? 'cursor-not-allowed' : ''"
            class="col-span-12 rounded-lg shadow divide-y divide-gray-200">
          <div class="w-full flex items-center bg-white justify-between p-6 space-x-6">
            <div class="flex-1 truncate">
              <div class="flex justify-center space-x-3">
                <h3 class="text-gray-900 text-lg font-bold truncate">{{ flow.name }}</h3>
              </div>
              <a-divider></a-divider>
              <div class="flex items-center space-x-3">
                <retro-flow-wizard :current_step="flow.config.length" :flow="flow.config"></retro-flow-wizard>
              </div>
            </div>
          </div>
          <div v-if="!flow.is_default">
            <div class="-mt-px flex divide-x divide-gray-200">
              <div class="w-0 flex-1 flex">
                <button
                    class="
                  hover:text-blue-400
                  relative
                  -mr-px
                  w-0
                  flex-1
                  inline-flex
                  items-center
                  justify-center
                  py-4
                  text-sm text-gray-700
                  font-medium
                  border border-transparent
                  rounded-bl-lg
                "
                    @click="editFlow(flow)"
                >
                  <PencilIcon class="hover:text-blue-400 w-5 h-5 flex-shrink-0 text-gray-700"></PencilIcon>
                </button>
              </div>
              <div class="-ml-px w-0 flex-1 flex">
                <button
                    class="
                  hover:text-blue-400
                  relative
                  w-0
                  flex-1
                  inline-flex
                  items-center
                  justify-center
                  py-4
                  text-sm text-gray-700
                  font-medium
                  border border-transparent
                  rounded-br-lg
                "
                    @click="deleteFlow(flow.id)"
                >
                  <TrashIcon class="hover:text-blue-400 w-5 h-5 flex-shrink-0 text-gray-700"></TrashIcon>
                </button>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </a-spin>
  </div>

</template>

<script>
import {defineComponent, onMounted, ref} from "vue";
import RetroFlowWizard from "./Components/RetroFlowWizard.vue";
import draggable from "vuedraggable";
import JetDialogModal from "@/Jetstream/DialogModal";
import {message} from "ant-design-vue";
import {TrashIcon, PencilIcon, CogIcon, PlusCircleIcon} from "@heroicons/vue/outline";
import {PERMISSION_DISPLAY_NAMES} from "@/constants";

export default {
  components: {RetroFlowWizard, JetDialogModal, TrashIcon, PencilIcon, CogIcon, PlusCircleIcon, draggable},
  setup() {
    const createModel = ref(false);
    const settingModal = ref(false);
    const flows = ref([]);
    const drag = ref(false);
    const selectedStep = ref();
    const loading = ref(false);
    const formData = ref({
      name: null,
    })

    const defaultFlow = ref([]);
    const customFlow = ref([]);
    const isCreate = ref(false);
    const selectedId = ref(null);
    const modalTitle = ref('');
    const modalButton = ref('');

    const getFlows = () => {
      loading.value = true;
      axios
          .get(route("retrospective.room.flow.get"))
          .then((response) => {
            loading.value = false;
            flows.value = response.data.data.list;
            defaultFlow.value = response.data.data.default;
          })
          .catch((error) => {
            loading.value = false;
            message.error("We cannot get retro flows.", 5);
          });
    };

    const modalSubmit = () => {
      if (isCreate.value) {
        createRetro()
      } else {
        updateFlow();
      }
    }
    const openCreateFlow = () => {
      createModel.value = true;
      customFlow.value = [...defaultFlow.value];
      formData.value.name = null;
      isCreate.value = true;
      modalTitle.value = 'Create Your Own Retro Flow';
      modalButton.value = 'CREATE FLOW';
      selectedId.value = null;
    }
    const editFlow = (element) => {
      createModel.value = true;
      customFlow.value = [...element.config];
      formData.value.name = element.name;
      isCreate.value = false;
      modalTitle.value = 'Edit Flow: ' + element.name;
      modalButton.value = 'EDIT FLOW';
      selectedId.value = element.id;
    }

    const deleteFlow = (id) => {
      if (confirm("Are you sure you want to delete it?")) {
        axios
            .delete(route("retrospective.room.flow.delete", {id: id}))
            .then((response) => {
              message.success("Your flow is deleted.");
              getFlows();
            })
            .catch((error) => {
              message.error("We cannot delete your flow.", 5);
            });
      }
    };

    const updateFlow = () => {
      loading.value = true;
      axios
          .put(route("retrospective.room.flow.update", {id: selectedId.value}), {
            ...formData.value,
            config: customFlow.value
          })
          .then((response) => {
            loading.value = false;
            createModel.value = false;
            getFlows();
          })
          .catch((error) => {
            loading.value = false;
            message.error("We cannot edit your flow.", 5);
          });
    }

    const changePermission = (checked, event) => {
      const {name} = event.target;
      selectedStep.value.permissions[name] = checked;
    };

    const deleteStep = (index) => {
      customFlow.value.splice(
          customFlow.value.findIndex((i, ind) => ind === index),
          1
      );
    };

    const createRetro = () => {
      if (!formData.value.name) {
        message.error("flow name is required.");
        return;
      }
      loading.value = true;
      axios
          .post(route("retrospective.room.flow.create"), {...formData.value, config: customFlow.value})
          .then((response) => {
            loading.value = false;
            createModel.value = false;
            getFlows();
          })
          .catch((error) => {
            loading.value = false;
            message.error("We cannot create your flow.", 5);
          });
    }
    const addStep = () => {
      customFlow.value.push({
        name: "New flow",
        desc: "New flow",
        permissions: {
          show_survey: false,
          sort_by_votes: false,
          can_move_cards: false,
          can_view_votes: false,
          can_vote_cards: false,
          can_merge_cards: false,
          can_create_actions: false,
          can_view_other_cards: false,
        },
      });
    };

    onMounted(() => {
      getFlows();
    });

    return {
      openCreateFlow,
      editFlow,
      loading,
      formData,
      modalSubmit,
      modalButton,
      modalTitle,
      PERMISSION_DISPLAY_NAMES,
      createModel,
      flows,
      drag,
      customFlow,
      settingModal,
      selectedStep,
      changePermission,
      addStep,
      deleteStep,
      getFlows,
      deleteFlow,
    };
  },
};
</script>

<style scoped lang="scss">

</style>
